import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import SobreNos from "./pages/SobreNos";
import Servicos from "./pages/Servicos";
import Tecnologias from "./pages/Tecnologias";
import Contato from "./pages/Contato";
import NossosEventos from "./pages/NossosEventos";
import ProgramaFidelidade from "./pages/ProgramaFidelidade";

function Router() {
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/sobre-nos"} component={SobreNos} />
      <Route path={"/servicos"} component={Servicos} />
      <Route path={"/tecnologias"} component={Tecnologias} />
      <Route path={"/contato"} component={Contato} />
      <Route path={"/nossos-eventos"} component={NossosEventos} />
      <Route path={"/programa-fidelidade"} component={ProgramaFidelidade} />
      <Route path={"/404"} component={NotFound} />
      {/* Final fallback route */}
      <Route component={NotFound} />
    </Switch>
  );
}

// NOTE: About Theme
// - First choose a default theme according to your design style (dark or light bg), than change color palette in index.css
//   to keep consistent foreground/background color across components
// - If you want to make theme switchable, pass `switchable` ThemeProvider and use `useTheme` hook

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="light"
        // switchable
      >
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
